module.exports = __webpack_public_path__ + "static/fairHarbor.311d7904.jpg";